import React, { useState } from "react";
import { Tabs } from "antd";
import ReportBuilder from "./ReportBuilder/ReportBuilder";
import AnalyticsSavedReports from "./AnalyticsSavedReports";
import trans from "../../utils";

const items = [
  { key: "builder", label: trans("Report Builder"), children: <ReportBuilder /> },
  { key: "saved", label: trans("Saved Reports"), children: <AnalyticsSavedReports /> },
];

export default function AnalyticsReports() {
  const [activeKey, setActiveKey] = useState("builder");
  return <Tabs activeKey={activeKey} onChange={setActiveKey} items={items} style={{ padding: 16 }} />;
}
